import Cookies from 'js-cookie';
import uuid from 'uuid';

// From https://github.com/robinhoodmarkets/rh/blob/master/web/shared/storage/src/constants/cookie.ts#L44
const deviceIdCookieKey = 'device_id';

export const randomDeviceId: () => string = () => {
  return uuid.v4();
};

export function setDeviceIdIfNotSet() {
  const deviceIdCookieValue = Cookies.get(deviceIdCookieKey);
  if (!deviceIdCookieValue) {
    const deviceId = randomDeviceId();
    Cookies.set(deviceIdCookieKey, deviceId, {
      expires: 365 * 10,
      secure: window.location.protocol === 'https:',
    });
  }
}

export function getDeviceId() {
  setDeviceIdIfNotSet();
  const deviceId = Cookies.get(deviceIdCookieKey);
  if (deviceId) {
    return deviceId;
  }
  return 'unknown';
}
